<template>
  <ButtonBase
    v-bind="$attrs"
    :class="classesButtonSave"
    size="M"
    :text="getTextSaveButton"
  >
    <template v-if="$slots.default" #default>
      <slot />
    </template>
  </ButtonBase>
</template>

<script lang="ts">
import style from "./ButtonSave.module.scss";
import {defineComponent, PropType} from "vue";
import ButtonBase from "@/elements/UI/button/ButtonBase/ButtonBase.vue";

export default defineComponent({
  name: "ButtonSave",
  inheritAttrs: false,
  components: {ButtonBase},
  props: {
    status: {
      type: String as PropType<StatusButtonSave>,
      default: "noChanges"
    }
  },
  data() {
    return {
      style
    };
  },
  computed: {
    classesButtonSave() {
      return [this.style.buttonSave, this.getStatusClass];
    },
    getStatusClass() {
      switch (this.status) {
        case "noChanges":
          return this.style.noChanges;
        case "unsaved":
          return this.style.unsaved;
        case "saving":
          return this.style.saving;
        case "saved":
          return this.style.saved;
        default:
          return this.style.error;
      }
    },

    getTextSaveButton() {
      switch (this.status) {
        case "noChanges":
          return "Сохранить";
        case "unsaved":
          return "Сохранить";
        case "saving":
          return "Сохраняем...";
        case "saved":
          return "Сохранено";
        default:
          return "Не сохранено";
      }
    }
  }
});
</script>
